<div class="flex direction-column item-center justify-center h-100">
  <img src="./assets/logo/genex-x-dark.svg" alt="GeneX" width="50">
  <h1>404</h1>
  <h2>{{'PageNotFound' | translate}}</h2>
  <!-- <p>{{'GoHome' | translate}}</p> -->
  <button class="go-back" (click)="goHome()">{{'GoBack' | translate}}</button>
</div>